import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { OnScreenMessagingService } from '@pattern-library/onscreen-messaging/onscreen-messaging.service';
import { LoggingService } from '@logging/logging.service';
import { ErrorHandlerService } from '@utils/error-handler.service';
import { ContactUsDataProvider } from './contact-us.data-provider';
import { ContactUsFormData } from './contact-us.model';
import { AbstractEntityStateService } from '@entity-framework/entity-record/state/abstract-entity.state-service';

@Injectable()
export class ContactUsStateService extends AbstractEntityStateService<ContactUsFormData> {
  private static storeName = 'contact-us';

  constructor(
    protected override dataProvider: ContactUsDataProvider,
    protected override route: ActivatedRoute,
    errorHandler: ErrorHandlerService,
    protected override messaging: OnScreenMessagingService,
    protected override logger: LoggingService,
    private formBuilder: FormBuilder
  ) {
    super(ContactUsStateService.storeName, dataProvider, route, errorHandler, messaging, logger);
  }

  setUpForm() {
    this.bindFormGroup(() => {
      this.logger.trace('ContactUsStateService: creating form');
      return this.createForm();
    });
  }

  public createForm() {
    return this.formBuilder.group({
      name: ['', [Validators.required]],
      companyName: ['', [Validators.required]],
      contactEmail: ['', [Validators.required, Validators.email]],
      contactTelephone: ['', [Validators.required]],
      reason: ['', [Validators.required]]
    });
  }
} 